<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Pagination from "@/components/standard/Accident/AccidentPagination";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
/**
 * Form elements component
 */
export default {
  page: {
    title: "3.2.2 Investigación de incidentes, accidentes de trabajo y enfermedades laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
  },
  data() {
    return {
      title:
        "3.2.2 Investigación de incidentes, accidentes de trabajo y enfermedades laborales",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.2.2 Investigación de incidentes, accidentes de trabajo y enfermedades laborales",
          active: true,
        },
      ],

      awesome: true,
      lista: [],
      type: [],
      subtype: [],
      listaII: [],
      file: null,

      item: null,
      itemStatus: "No cumplido",
      loading1: true,
      itemData: null,

      accident: {
        accident_report_types_id: null,
        report_subtypes_id: null,
        report_date: null,
        hour: null,
        description: null,
        improvement_plan: null,
        arl_report_date: null,
        file: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
        company_classification_id: this.$store.getters["company/getCompany"].company_classification_id || null,
        items_id: 32,
      },

      itemsAgregar: {
        companies_id: this.$store.getters["company/getCompany"].id || null,
        items_id: 32,
        status: null,
        operation: "suma",
        company_classification_id: this.$store.getters["company/getCompany"].company_classification_id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],

      itemcheck: {
        companies_id: this.$store.getters["company/getCompany"].id || null,
        items_id: 32,
      },

      nit: this.$store.getters["company/getCompany"].nit || null,
      // Item 3.2.2: subida del FURAT por reporte de accidente
      furatTarget: null,
      furatUploadingId: null,
      furatAccept: ".pdf,.xlsx,.xls,.csv,.txt,.doc,.docx",
      furatExtensions: ["pdf", "xlsx", "xls", "csv", "txt", "doc", "docx"],

      exist: false,
      deleteCount: 0,
      search: "",
      loading: true,
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 33)
        .then((response) => {
          this.exist = response.id ? true : false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItemData() {
      ItemAPI.getItems(33)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 33)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 33,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        company.id_diseno_sso,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getType() {
      accidentAPI
        .getType()
        .then((response) => {
          this.type = response.Accident_report_type;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getSubType() {
      accidentAPI
        .getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          this.type = typeAccident;
          this.subtype = typeAccident[0].report_subtype;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      accidentAPI
        .getAllAccident(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.Accident_report.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteInvestigacion(id) {
      accidentAPI.delete(id).then((data) => {
        if (this.deleteCount > 0) {
          this.deleteCount -= 1;
        }
        const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
        const itemChange = {
          companies_id: this.companyID,
          item_id: 33,
          status: newStatus,
        };
        newScoresAPI.calculateScores(itemChange)
          .then((response) => {
            Swal.fire({
              title: "Éxito!",
              text: "Se ha sido eliminado con éxito!",
              icon: "success",
              type: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload();
          })
          .catch((error) => {
            this.loading = false
            setTimeout(() => {
              Swal.fire({
                title: "Error",
                text: "¡No se ha podido registrar!",
                icon: "error",
                type: "error",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            }, 1000);
            console.log(error);
          });
      })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    /** Reporte de accidente mas reciente del colaborador (el que pinta la fila) */
    getAccidentReport(dato) {
      return dato.accident_reports && dato.accident_reports.length > 0
        ? dato.accident_reports[0]
        : null;
    },

    /** URL del FURAT ya adjunto, o null */
    getFuratFile(dato) {
      const report = this.getAccidentReport(dato);
      return report && report.furat_file ? report.furat_file : null;
    },

    /** Abre el selector de archivos apuntando al reporte de la fila */
    pickFurat(dato) {
      const report = this.getAccidentReport(dato);
      if (!report) return;
      this.furatTarget = report;
      // Se limpia para que volver a elegir el mismo archivo dispare el change
      this.$refs.furatInput.value = "";
      this.$refs.furatInput.click();
    },

    /** Sube el FURAT al bucket y guarda la URL en el reporte de accidente */
    async onFuratSelected(event) {
      const file = event.target.files && event.target.files[0];
      const report = this.furatTarget;
      if (!file || !report) return;

      const extension = file.name.split(".").pop().toLowerCase();
      if (!this.furatExtensions.includes(extension)) {
        Swal.fire({
          title: "Formato no permitido",
          text: "El FURAT debe ser un archivo PDF, Excel o de texto.",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        return;
      }

      this.furatUploadingId = report.id;
      try {
        const folder = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${folder}/${this.nit}/3.2.2/${report.employee_id}/FURAT/${file.name}`;

        const uploaded = await uploadDocument(path, file);
        if (!uploaded) throw new Error("No se pudo subir el archivo al bucket");

        const url = `${process.env.VUE_APP_BUCKET}/${path}`;
        await accidentAPI.updateFurat(report.id, url);
        this.$set(report, "furat_file", url);

        Swal.fire({
          title: "¡Éxito!",
          text: "¡El FURAT se adjuntó con éxito!",
          icon: "success",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      } catch (error) {
        console.log(error);
        Swal.fire({
          title: "¡ERROR!",
          text: "¡No se pudo adjuntar el FURAT!",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      } finally {
        this.furatUploadingId = null;
        this.furatTarget = null;
      }
    },

    getInvestigationFile(dato) {
      const report = dato.accident_reports && dato.accident_reports[0];
      if (!report) return null;
      const investigation = report.accident_investigation && report.accident_investigation[0];
      if (!investigation) return null;
      const images = investigation.imagen_investigations;
      if (!images || images.length === 0) return null;
      const last = images[images.length - 1];
      return last && last.file ? last.file : null;
    },
  },

  mounted() {
    this.getUsers();
    this.getItems();
    this.getItem();
    this.getList();
    this.getItemData();
    this.getType();
    this.getSubType();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      El responsable de implementación, en compañía del copasst
                      debe registrar y luego proceder con la investigación de
                      los accidentes de trabajo.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <form class="form-group pt-2">
                <hr v-if="getRole('Consultar')" />
                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-md-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <div v-if="!loading1">
                          <table :disabled="!getRole('Consultar') || !allowAccess()"
                            class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                            <thead>
                              <tr>
                                <th>Colaborador</th>
                                <th class="text-center align-middle">Tipo</th>
                                <th class="text-center align-middle">Fecha</th>
                                <th class="text-center align-middle">
                                  Archivo
                                </th>
                                <th class="text-center align-middle">
                                  FURAT
                                </th>
                                <th class="text-center align-middle pl-4">
                                  Acciones
                                </th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr :disabled="!getRole('Consultar') || !allowAccess()
                                " v-for="dato in lista" :key="dato.id">
                                <td>
                                  {{ dato.full_name }}
                                </td>
                                <td class="text-center align-middle">
                                  <div v-if="dato.accident_reports.length > 0">
                                    <div v-if="dato.accident_reports[0]
                                      .accident_report_types_id === 1
                                    ">
                                      <h6>Accidente</h6>
                                    </div>
                                    <div v-else-if="dato.accident_reports[0]
                                      .accident_report_types_id === 2
                                    ">
                                      <h6>Incidente</h6>
                                    </div>
                                    <div v-else-if="dato.accident_reports[0]
                                      .accident_report_types_id === 3
                                    ">
                                      <h6>Enfermedad laboral</h6>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <h6>Sin registros</h6>
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  {{
                                    dato.accident_reports.length > 0
                                      ? dato.accident_reports[0].report_date
                                      : "Sin registro"
                                  }}
                                </td>

                                <td :disabled="!getRole('Consultar') || !allowAccess()"
                                  class="text-center align-middle">
                                  <div v-if="getInvestigationFile(dato)">
                                    <button :disabled="!getRole('Consultar') || !allowAccess()
                                      " style=" background-color: transparent !important; border: none; " type="button"
                                      @click="gotoDigitalOcean(getInvestigationFile(dato))">
                                      <i class="mdi mdi-cloud-download"></i>
                                    </button>
                                  </div>
                                  <div v-else>
                                    <h6>Sin archivo</h6>
                                  </div>
                                </td>

                                <td class="text-center align-middle">
                                  <div v-if="!getAccidentReport(dato)">
                                    <h6>Sin registros</h6>
                                  </div>
                                  <div v-else-if="furatUploadingId === getAccidentReport(dato).id">
                                    <b-spinner small variant="primary" label="Subiendo..."></b-spinner>
                                  </div>
                                  <div v-else-if="getFuratFile(dato)">
                                    <button style="background-color: transparent !important; border: none;"
                                      type="button" :disabled="!getRole('Consultar') || !allowAccess()"
                                      title="Descargar FURAT" @click="gotoDigitalOcean(getFuratFile(dato))">
                                      <i class="mdi mdi-cloud-download"></i>
                                    </button>
                                    <button type="button" class="btn btn-link btn-sm p-0"
                                      :disabled="!getRole('Crear') || !allowAccess()" @click="pickFurat(dato)">
                                      Cambiar
                                    </button>
                                  </div>
                                  <div v-else>
                                    <button type="button" class="btn btn-primary btn-sm text-nowrap"
                                      :disabled="!getRole('Crear') || !allowAccess()" @click="pickFurat(dato)">
                                      <i class="mdi mdi-paperclip"></i> Adjuntar FURAT
                                    </button>
                                  </div>
                                </td>

                                <td class="text-center align-middle pl-4">
                                  <div class="col-sm-12">
                                    <div v-if="dato.accident_reports.length > 0">
                                      <b-dropdown variant="primary">
                                        <template v-slot:button-content>
                                          <i class="mdi mdi-eye"></i>
                                        </template>

                                        <b-dropdown-item v-if="dato.accident_reports[0]
                                          .accident_report_types_id === 2
                                        " disabled :to="{
                                          path: `/forms/estandares/${dato.companies_id}/investigacion-crear/${dato.accident_reports[0].id}`,
                                        }">
                                          Investigación</b-dropdown-item>
                                        <b-dropdown-item v-else :disabled="!getRole('Consultar') ||
                                          !allowAccess()
                                          " :to="{
                                            path: `/forms/estandares/${dato.companies_id}/investigacion-crear/${dato.accident_reports[0].id}`,
                                          }">
                                          Investigación</b-dropdown-item>
                                        <b-dropdown-item :disabled="dato.accident_reports[0]
                                          .accident_investigation[0] &&
                                          dato.accident_reports[0]
                                            .accident_investigation[0]
                                            .close_investigation === 'SI'
                                          " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>

                                        <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer
                                          size="sm">
                                          <div class="text-justify">
                                            <h4 class="mt-2 text-primary text-center">
                                              Advertencia
                                            </h4>
                                            <p class="mt-3">
                                              Al modificar esta información se
                                              quitará el puntaje correspondiente
                                              a este ítem y será necesario
                                              realizar nuevamente la validación
                                              por parte del usuario responsable
                                              de Emisión.
                                            </p>
                                            <button :disabled="!getRole('Editar') ||
                                              !allowAccess()
                                              " type="button" class="btn btn-primary my-2 mx-2">
                                              <router-link class="text-white" :to="{
                                                path: `/forms/estandares/${dato.companies_id}/investigacion-editar/${dato.accident_reports[0].id}`,
                                              }">Editar
                                              </router-link>
                                            </button>
                                            <button type="button" @click="
                                              $bvModal.hide(`modal${dato.id}`)
                                              " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                              Cancelar
                                            </button>
                                          </div>
                                        </b-modal>
                                        <b-dropdown-item :disabled="!getRole('Eliminar') ||
                                          !allowAccess()
                                          " v-on:click="
                                            deleteInvestigacion(dato.id)
                                            ">Eliminar</b-dropdown-item>
                                      </b-dropdown>
                                    </div>
                                    <div v-else></div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else>
                          <div class="text-center pt-2">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                          </div>
                        </div>
                        <input ref="furatInput" type="file" class="d-none" :accept="furatAccept"
                          @change="onFuratSelected" />

                        <div>
                          <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                            @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
